import { jsx } from "panel";
import { BannerEl } from "common/components/banner";
import { BannerAction, BannerSize, BannerType } from "common/components/banner/types";
export function template() {
  return /* @__PURE__ */ jsx("div", { sel: ".sharing-banner", "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, this.helpers.shouldShow() ? /* @__PURE__ */ jsx(BannerEl, { attrs: {
    elref: "shareBanner",
    theme: "info",
    type: BannerType.Embedded,
    size: BannerSize.Small,
    "body-text": this.helpers.getShareBannerText(),
    ctas: window.localStorage && [{
      text: "Dismiss",
      actionName: BannerAction.Dismiss
    }],
    "style-override": "\n          .banner-wrapper .banner-panel {padding: 8px;}\n          .banner-wrapper .banner-panel .banner-actions {margin-bottom: 0}\n          .banner-wrapper .banner-panel .banner-copy {margin-bottom: 0}\n          .banner-wrapper .banner-panel .banner-actions .cta-button.banner-action-button-embedded.info-theme {border: none;}\n        "
  }, on: {
    action: this.helpers.handleBannerAction
  } }) : null);
}
